import { ToolTye } from '@/components/Note/utils';
import React from 'react';
import { useIntl } from 'umi';
import s from './index.less';
import Icon from '@/components/Icon';
import classNames from 'classnames';
import SelectBox from '../select-box';
import { PEN_WIDTH } from '../../types';
import { Tooltip } from '@/components';
import HoverIcon from '@/pages/Meeting/component/BarragePanel/components/HoverIcon';
import PenIcon from '../PenIcon';

export type PenSelectValue = {
  type: ToolTye;
  pen_width?: PEN_WIDTH;
};
interface PenSelectProps {
  value: PenSelectValue;
  onChange: (value: PenSelectValue) => void;
}

const PenSelect: React.FC<PenSelectProps> = (props) => {
  const { value, onChange } = props;
  const { formatMessage } = useIntl();
  const onSelectWidth = (pen_width: PEN_WIDTH) => {
    onChange({ type: value.type, pen_width: pen_width });
  };
  const change = (type: ToolTye) => {
    console.log(value);
    onChange({ type, pen_width: value.pen_width });
  };
  return (
    <SelectBox
      topTitle={formatMessage({ id: 'pen' })}
      bottomTitle={formatMessage({ id: 'lineWidth' })}
      TopComponent={
        <>
          <PenIcon
            title={formatMessage({ id: 'penInk' })}
            name="icon-brush"
            className={classNames(s.item, value.type === ToolTye.PEN ? s.active : '')}
            onClick={() => change(ToolTye.PEN)}
          ></PenIcon>
          <PenIcon
            title={formatMessage({ id: 'marker' })}
            name="icon-brush31"
            className={classNames(s.item, value.type === ToolTye.PEN_MARKR ? s.active : '')}
            onClick={() => change(ToolTye.PEN_MARKR)}
          ></PenIcon>
        </>
      }
      BottomComponent={
        <>
          <PenIcon
            name="icon-a-Vector513Stroke"
            className={classNames(
              s.item,
              value.pen_width === PEN_WIDTH.WIDTH_ULTRA_FINE ? s.active : ''
            )}
            onClick={() => onSelectWidth(PEN_WIDTH.WIDTH_ULTRA_FINE)}
          ></PenIcon>

          <PenIcon
            name="icon-a-Vector514Stroke"
            className={classNames(
              s.item,
              value.pen_width === PEN_WIDTH.WIDTH_STANDARD ? s.active : ''
            )}
            onClick={() => onSelectWidth(PEN_WIDTH.WIDTH_STANDARD)}
          ></PenIcon>

          <PenIcon
            name="icon-a-Vector515Stroke"
            onClick={() => onSelectWidth(PEN_WIDTH.WIDTH_BOLD)}
            className={classNames(s.item, value.pen_width === PEN_WIDTH.WIDTH_BOLD ? s.active : '')}
          ></PenIcon>

          <PenIcon
            name="icon-a-Vector516Stroke"
            onClick={() => onSelectWidth(PEN_WIDTH.WIDTH_ULTRA_BOLD)}
            className={classNames(
              s.item,
              value.pen_width === PEN_WIDTH.WIDTH_ULTRA_BOLD ? s.active : ''
            )}
          ></PenIcon>
        </>
      }
    ></SelectBox>
  );
};

export default PenSelect;
